export { MonopolyTurnGameCoreModule } from './monopoly-turn-game-core.module';
export { MonopolyTurnGameSelectorComponent } from './monopoly-turn-game-selector/monopoly-turn-game-selector.component';
export { MonopolyTurnGameCoreService } from './monopoly-turn-game-core.service';
export { IMonopolyTurnGame } from './monopoly-turn-game.interface';
